import { TrackingSources } from './constants';
import type { TrackingContextValue } from './types';

export const DEFAULT_TRACKING_CONFIG: TrackingContextValue = {
  enabled: true,
  source: TrackingSources.Prematch,
};

export const PREMATCH_TRACKING_CONFIG: TrackingContextValue = {
  enabled: true,
  source: TrackingSources.Prematch,
};

export const MINI_TRACKING_CONFIG: TrackingContextValue = {
  enabled: false,
  source: TrackingSources.Mini,
};
